const data = {
  diseño: [
    {
      'created_at': '2022-08-30T13:52:23.000Z',
      'id': '1564611995818680332',
      'text': 'Si querés aprender Diseño UX/UI, pero no sabes cómo, esta es tu oportunidad.\n\nHoy te comparto CURSOS PARA APRENDER DISEÑO UX/UI DE FORMA GRATUITA 🔥'
    },
    {
      'created_at': '2022-02-21T12:26:37.000Z',
      'id': '1495736715255984129',
      'text': 'Buen comienzo de semana ☀️ \n\nHoy les traigo un nuevo recurso gratuito para el toolkit del desarrollador y diseñador: GUÍA DE ACCESIBILIDAD WEB 🎁 https://t.co/S53KEr97Oo'
    },
    {
      'created_at': '2022-06-13T22:16:43.000Z',
      'id': '1536472659881512961',
      'text': 'Así como a hacer se aprende haciendo, UX se aprende practicando. 💛\n\nHoy vengo con un tremendo hilo sobre aprender y practicar UX para optimizar tu carrera en diseño de experiencias. Viene con bonus de recursos! 👀 \n\nEmpecemos!🧵 👇'
    },
    {
      'created_at': '2021-12-07T14:11:42.000Z',
      'id': '1468221686109585410',
      'text': 'Cuándo se usan los prototipos en baja, media y alta fidelidad? De qué hablamos cuando hablamos de "fidelidad"? \n\nHoy en ✨ conceptos básicos de UX ✨ hablemos de todo lo que tenés que saber sobre prototipado para que tu proceso de diseño sea im-pe-ca-ble. 🧵👇'
    },
    {
      'created_at': '2021-12-01T14:45:53.000Z',
      'id': '1382344361610973184',
      'text': '✏️ Hablemos de cómo obtener inspiración para nuestros proyectos digitales 👩‍💻\n\nEl moodboard es una técnica creativa visual que ayuda a comunicar ideas por medio de imágenes, texturas, frases, fotografías, etc. + https://t.co/kF9pB9cwsQ'
    },
    {
      'created_at': '2021-11-02T23:54:14.000Z',
      'id': '1455684708226977792',
      'text': '10 principios de Accesibilidad que todo Desarrollador/Diseñador Web debería conocer y aplicar a sus proyectos + Guía gratis 🤓\n\n¡Diseño para todas y todos! 👇'
    },
    {
      'created_at': '2021-10-20T16:39:17.000Z',
      'id': '1450864205574385666',
      'text': 'El hilo de hoy es cortito y al pie: hagamos una checklist con los atributos que tenés que tener en cuenta para mejorar al 100% tus diseños 🚀\n\nY viene con herramientas gratuitas súper útiles para que se lleven 😏 +'
    },
    {
      'created_at': '2021-10-13T17:14:47.000Z',
      'id': '1448336427381579778',
      'text': '10 websites con recursos para Diseñadores que no solo deberías conocer, sino que también deberías usar si estás creando sus propios sitios web o aplicaciones 👩‍💻'
    },
    {
      'created_at': '2021-09-29T13:12:36.000Z',
      'id': '1443202048036593669',
      'text': 'Atención UX/UI designers!\nHoy vengo con tips, consejos y herramientas útiles para diseñar buenas interfaces de usuario. 🛠️\nEmpezamos en 3, 2, 1 YA 🧵'
    },
    {
      'created_at': '2021-03-31T11:25:08.000Z',
      'id': '1377220413273608194',
      'text': 'Hablemos de sistemas de diseño ✏️ Empecemos con saber ¿Qué es un sistema de diseño? Es una herramienta colaborativa, creada por componentes reutilizables y guiada por principios. Es todo lo que hace a la construcción y composición de un producto (aplicación o página web) + https://t.co/62cLGIRivz'
    },
    {
      'created_at': '2021-06-09T20:14:54.000Z',
      'id': '1402720881089171460',
      'text': 'Cómo automatizar tareas con Figma? 🖥️\nHoy te traigo plugins de Figma para que trabajes más rápido y fácil. Atención diseñadores 👇'
    },
    {
      'created_at': '2021-04-09T15:02:47.000Z',
      'id': '1380536675546320896',
      'text': '🚀 UX/UI DESIGNER PORTFOLIO:\nEsta semana estuve trabajando en mi portfolio y quería compartirles lo que aprendí de varios procesos de reclutamiento 💛  \nAsique abro hilo con preguntas frecuentes y tips para que diseñen u optimicen su porftolio de diseño +'
    },
    {
      'created_at': '2021-06-01T11:44:50.000Z',
      'id': '1399693418679476228',
      'text': 'Dónde estudiar Diseño UX/UI online? \nAbro hilo con buenas ofertas educativas en el mercado 👩‍💻'
    },
    {
      'created_at': '2021-04-12T09:59:50.000Z',
      'id': '1381547600696983552',
      'text': '✏️Conocen daily UI? https://t.co/GHPbU44kpY Se trata de una plataforma en la que se suscriben y reciben un mail diario (excepto fines de semana) con pequeños retos que pueden ayudar a mejorar habilidades de la interfaz de usuario como tipografía, jerarquía, color, diseño 🎨 +'
    },
    {
      'created_at': '2021-07-02T18:30:00.000Z',
      'id': '1411029405686661122',
      'text': 'Hoy les traigo distintas plataformas de ejercicios para aprender Diseño UX/UI de forma didática y divertida 🚀\n\n1. https://t.co/8Loi3i919e\n2. https://t.co/cOPszYx7i5\n3. https://t.co/SBdTld3Wu5\n\nQue las disfruten! 🎨'
    },
    {
      'created_at': '2021-03-01T13:01:45.000Z',
      'id': '1366373092885491714',
      'text': 'Hoy les traigo CURSOS GRATIS DE UX/UI 📚\n1. UX Design: Conceptos básicos para principiantes https://t.co/xWpP37JkZl \n2. Fundamentos del diseño UX https://t.co/fQQ9A4LTz1\n3. Adobe XD: Aprender a crear prototipos profesionales desde 0 https://t.co/S01Am6qd7M'
    },
    {
      'created_at': '2021-03-05T15:35:17.000Z',
      'id': '1367861278199447552',
      'text': 'UX STARTER PACK BABY 🚀 la semana pasada les dejé recursos y herramientas de Diseño UX/UI, hoy quiero recomendarles libros, blogs, charlas y newsletters para aquellos que están comenzando en este hermoso mundo del UX (o aquellos como yo que aman la capacitación constante 😍) +'
    },
    {
      'created_at': '2021-03-26T12:10:31.000Z',
      'id': '1375419895920394243',
      'text': 'buen día! aquí les dejo el link a un tablero con información, recursos y herramientas de UX/UI 🚀 que armé especialmente para que tengan todo en un sólo lugar.\n📌 https://t.co/zUWWFTr7AG'
    },
    {
      'created_at': '2021-02-26T18:35:53.000Z',
      'id': '1365370012920332295',
      'text': '🧵 HILO DE RECURSOS Y HERRAMIENTAS PARA DISEÑO UX/UI ✨ Me basé en esta guía que encontré super interesante (https://t.co/dN9BA1O5WV) para organizar los recursos en cada etapa del proceso de diseño. Y ya saben que si quieren sumar info, SIEMPRE es más que bienvenida +'
    },
    {
      'created_at': '2021-05-14T16:08:51.000Z',
      'id': '1393236876744593415',
      'text': 'Hola amiguitos, les traigo un artículo que escribí para empezar en el diseño UX/UI de 0 a 100 🚀\nEs una guía SÚPER completa basada en mi experiencia, llena de recursos e ideas. Lean y compartan!  \n\nhttps://t.co/qQxZYNCPKQ'
    },
    {
      'created_at': '2021-05-06T20:21:03.000Z',
      'id': '1390401242153824260',
      'text': '¿DISEÑO WEB y DESARROLLO WEB son lo mismo? Hablemos sobre estos dos grandes conceptos 🧵+'
    },
    {
      'created_at': '2020-12-07T13:01:04.000Z',
      'id': '1335932340103766016',
      'text': 'QUÉ ES UX/UI, FRONT-END y BACK-END Y DÓNDE ESTUDIARLO? Bueno tengo que presentar un prototipo en unas horas asique sale hilo rápido, como siempre, no tengo la verdad absoluta y cualquier comentario es más que bienvenido ✨(abro hilo)'
    },
  ],
  programacion: [
    {
      'created_at': '2021-11-10T13:41:49.000Z',
      'id': '1458429691858141186',
      'text': 'UI React Frameworks para tus proyectos de Desarrollo Web 👩‍💻 🔥\n\n📌 https://t.co/bWw7EviBOl \n📌 https://t.co/I9E23dRMRm\n📌 https://t.co/azyMI1O2yY \n📌 https://t.co/uQHO1c2XZh\n📌 https://t.co/vfAWiDs9qi\n📌 https://t.co/CdYmNCpHjs\n+'
    },
    {
      'created_at': '2021-10-26T14:23:24.000Z',
      'id': '1453004340386574338',
      'text': 'Como programador, deberías conocer los fundamentos de los algoritmos 🔥\n\n👉 Aprende a escribir pseudocódigo\n👉 Comprender la estructura de datos básica\n          Arrays\n          Matrices \n          Pilas\n          Colas'
    },
    {
      'created_at': '2021-10-11T21:24:05.000Z',
      'id': '1447674387793158144',
      'text': 'Repositorios de Github para programadores 👩‍💻 👇 \n\n⚡️ Recursos de UX/UI para desarrolladores: https://t.co/UGdIcN9WVC\n\n⚡️ Creadores de contenido de programación y diseño: https://t.co/uID3NkF84J \n\n⚡️ Roadmap para convertirte en Desarrollador Web 2021:\nhttps://t.co/PkWBn1PVPJ \n+'
    },
    {
      'created_at': '2021-10-04T13:38:57.000Z',
      'id': '1445020619486154759',
      'text': 'Herramientas para Desarrolladores Web que deberías agregar a tu Toolkit 🛠️\n\nParte II de la Guía de Desarrollo Web 🥳 https://t.co/huxJNhiYOT 🧵'
    },
    {
      'created_at': '2021-09-27T14:58:52.000Z',
      'id': '1442504018002169860',
      'text': 'Hoja de ruta: Aprendé Desarrollo Web Front-End 🚀 🧵'
    },
    {
      'created_at': '2021-09-27T11:03:34.000Z',
      'id': '1442444799970320386',
      'text': 'Miren este TREMENDO sitio web para desarrolladores.\n\nUn lugar donde podés aprender cualquier lenguaje y su framework gratis. 🔥\n\n👉 https://t.co/7ORvQ8g0Na'
    },
    {
      'created_at': '2021-09-17T15:06:52.000Z',
      'id': '1438882149336240131',
      'text': 'Herramientas de Desarrollo Web para hacer el trabajo más ágil y ahorrar muchas horas a la semana ⏰'
    },
    {
      'created_at': '2021-09-02T14:52:05.000Z',
      'id': '1433442613886128131',
      'text': 'Los mejores generadores CSS para el Diseño Web 🚀\n\nCada una de estas herramientas están especializadas en un trabajo en concreto de las muchas propiedades con que cuenta CSS. Son muy fáciles de usar y tienen una vista previa para ver los resultados.\n\nA thread 🧵'
    },
    {
      'created_at': '2021-08-21T20:47:39.000Z',
      'id': '1429183441187352583',
      'text': '¿Sabes cuál es la mejor manera de aprender cualquier lenguaje de programación? 🤓\n\nLa respuesta es haciendo muchos proyectos! \n\nAquí les dejo una lista completa de tutoriales basados en proyectos para aprender HTML / CSS / Javascript para principiantes 🤟'
    },
    {
      'created_at': '2021-08-18T14:26:47.000Z',
      'id': '1428000427891732480',
      'text': 'La guía definitiva para iniciarse en el desarrollo web 🚀 (parte I)\n\nHilo lleno de recursos, información y links para empezar en el mundo gigante de la programación. Que lo disfruten! 👇'
    },
    {
      'created_at': '2021-07-28T13:24:11.000Z',
      'id': '1420374527536685061',
      'text': 'Recursos gratis para aprender React.js 🚀👇'
    },
    {
      'created_at': '2021-07-21T20:59:13.000Z',
      'id': '1417952327105974272',
      'text': 'Aprende a programar en Python gratis con estos recursos 👩‍💻👇'
    },
    {
      'created_at': '2021-07-19T13:49:06.000Z',
      'id': '1417119307222355976',
      'text': 'Recursos gratis para aprender JavaScript 🚀\n\nA thread 🧵'
    },
    {
      'created_at': '2021-07-16T13:34:58.000Z',
      'id': '1416028587510190086',
      'text': '7 websites para practicar Desarrollo Web y mejorar tus skills 🛸😎\n\n1️⃣ https://t.co/3kAYLk3bYB\n2️⃣ https://t.co/bkjytIx69l \n3️⃣ https://t.co/uUmFISAMK9 \n4️⃣ https://t.co/RamzkuWLOK\n5️⃣ https://t.co/gyXMOc07fr\n6️⃣ https://t.co/77mKOF7kZM\n7️⃣ https://t.co/R34X0y7ny6'
    },
    {
      'created_at': '2021-07-13T22:54:56.000Z',
      'id': '1415082344998965249',
      'text': 'Estás empezando a estudiar desarrollo web y no te queda claro cómo se combina con otras disciplinas, como el diseño UX/UI? \nCuando empecé nadie me lo dijo, así que abro hilo con todo el proceso de crear un sitio web desde 0. No más dudas 👇'
    },
    {
      'created_at': '2021-07-12T17:19:00.000Z',
      'id': '1414635414883737603',
      'text': 'Quiero agregar algo FUNDAMENTAL para comenzar con cualquier lenguaje de programación: aprender lógica, algoritmos, flujos de datos y pseudocódigo. \n\nSobre esto les dejo un curso gratis https://t.co/9SEopDvAvC y una guía en PDF que pueden descargar aquí https://t.co/pNeb5jORDj 🚀 https://t.co/ziaSmRqSoB'
    },
    {
      'created_at': '2021-05-17T23:08:22.000Z',
      'id': '1394429618560643073',
      'text': 'a ver, esto va a ser rápido. \nuno: iniciar sesión\ndos: inscribirse a los CURSOS GRATIS DE PROGRAMACIÓN 👇\ntres: estudiar y practicar\nzip, zap, terminé\nesto es ser un profesional niños  + https://t.co/nnfnlaK2SY'
    },
    {
      'created_at': '2021-06-22T18:44:48.000Z',
      'id': '1407409249018318852',
      'text': 'CÓMO EMPEZAR A PROGRAMAR? 👩‍💻\nHay muchísima info sobre cómo arrancar en el mundo del desarrollo web y los mil lenguajes que deberías aprender, pero nadie te dice en qué orden hacerlo. \nTe preparo una ruta para que construyas tu carrera desde 0:'
    },
    {
      'created_at': '2021-05-06T20:21:03.000Z',
      'id': '1390401242153824260',
      'text': '¿DISEÑO WEB y DESARROLLO WEB son lo mismo? Hablemos sobre estos dos grandes conceptos 🧵+'
    },
  ],
  marketing_digital: [
    {
      'created_at': '2021-03-21T20:04:16.000Z',
      'id': '1373727179314454534',
      'text': 'mientras tanto les vuelvo a dejar el drive con recursos, herramientas y cursitos de Marketing Digital y Redes Sociales 🚀 https://t.co/tF84EOxe32'
    },
  ],
  productividad: [
    {
      'created_at': '2022-05-04T13:36:49.000Z',
      'id': '1521846310902632449',
      'text': 'Volvieron los hilos! 🤩\n\nMe leen personas de edades y situaciones diferentes, pero la pregunta \'cómo hago para estudiar y trabajar a la vez\' es una de las que más recibo. \n\n🙌 Hoy les traigo un hilo sobre cómo estudiar y trabajar sin morir en el intento + tools de organización🧵'
    },
    {
      'created_at': '2021-10-15T18:58:14.000Z',
      'id': '1449087235853275145',
      'text': 'Si estás todo el día haciendo cosas ⌛ pero igual no llegas a terminar todas tus tareas, este hilo es para vos.\n\nHablemos sobre qué es (y qué no es) la productividad. Al final les dejo tips y herramientas para optimizar su tiempo y aprovecharlo al máximo 🙌. \n\nAcompáñenme! 🧵👇'
    },
    {
      'created_at': '2021-05-10T19:39:56.000Z',
      'id': '1391840446641577988',
      'text': 'Hoy les traigo 4 herramientas gratuitas para organizar tu vida personal y profesional. ORGANIZA TUS PROYECTOS 🚀 +'
    }
  ],
  freelance: [
    {
      'created_at': '2021-09-07T21:51:28.000Z',
      'id': '1435360093646860294',
      'text': 'El ABC del freelancer 🤝Válido para Marketing Digital, Diseño, Desarrollo y todo lo que se pueda freelancear.\n\nLas mejores plataformas online para trabajar freelance y remoto, monotributo, presupuestos, deadlines, portfolio y un montón de consejos en este SEÑOR hilo. 🧵'
    },
    {
      'created_at': '2021-07-27T12:48:13.000Z',
      'id': '1420003089810087938',
      'text': 'Atención diseñadores y desarrolladores web 📣\n\nLes dejo los 10 mejores sitios para buscar trabajo como Freelancer 👩‍💻\n\n1️⃣LinkedIn https://t.co/YV36T7PjLI \n2️⃣ Designhill https://t.co/ijxxAwefV4\n3️⃣ TopTotal https://t.co/Vv4AaOPRpR\n4️⃣ Upwork  https://t.co/csAE56Uqyg\n+'
    },
    {
      'created_at': '2021-03-11T20:29:05.000Z',
      'id': '1370109542571380751',
      'text': 'Hablemos de CÓMO PRESUPUESTAR TU TRABAJO 🤑 Qué valor le pongo a mi trabajo? Qué tipo de presupuesto envío? Qué debe contener el documento? Sigan leyendo que en este hilo voy a dejarles algunos tips y plantillas editables que pueden personalizar y utilizar en sus presupuestos +'
    },
    {
      'created_at': '2020-08-22T17:46:28.000Z',
      'id': '1297228660567617541',
      'text': '[CÓMO CONSEGUIR TRABAJO FREELANCE]\nvoy a empezar diciendo que no soy parámetro de nada, lo que voy a compartir es mi experiencia y opinión, asique cualquier cosa que quieras agregar será súper bienvenida +'
    },

  ],
  ingles: [
    {
      'created_at': '2021-08-26T17:29:14.000Z',
      'id': '1430945444511850506',
      'text': 'Deberías estar aprendiendo inglés AYER.\nNo solo porque si trabajas en tech es uno de los skills más importantes, sino porque es la forma más segura y directa de conseguir un trabajo EN DÓLARES.\nA continuación, mi recomendación  (y descuento 😏) para aprender con los mejores 👇'
    }
  ],
  trabajoIt: [
    {
      'created_at': '2021-08-15T17:44:42.000Z',
      'id': '1426963073169035268',
      'text': 'Ingresa en el mercado laboral IT con esta info 🧵\n\n✅  Armado de CV\n✅  Cómo optimizar tu perfil de Linkedin\n✅  Diseño de portfolio profesional \n✅  Preparación para entrevistas laborales \n✅  El ABC del Freelancer\n✅  Marca personal\n✅  Cómo armar un presupuesto \n\n¡Y más! 👇'
    },
    {
      'created_at': '2022-06-28T19:08:47.000Z',
      'id': '1541861186173534210',
      'text': '¿Estás buscando trabajo en IT o ya estás trabajando pero te diste cuenta de que necesitás mejorar tu inglés? Entonces este hilo es para vos 🧵👇'
    },
    {
      'created_at': '2022-01-04T15:43:24.000Z',
      'id': '1478391619858665474',
      'text': 'Hoy quiero hablar sobre las entrevistas laborales, pero no desde el enfoque de siempre, que es el pasivo: qué decir, cómo responder, cómo respirar 🙄. Quiero que cambiemos el mindset a uno mucho más activo y proactivo.\n\nDicho esto, abro hilo sobre cómo afrontar una entrevista.🧵'
    },
    {
      'created_at': '2021-12-16T15:58:21.000Z',
      'id': '1471510015227809798',
      'text': 'El teletrabajo llegó para quedarse. En estos (casi) dos años trabajé en remoto para tres empresas y varios proyectos, así que aprendí bastante sobre trabajar desde casa. Hoy quiero compartirlo con ustedes. \n\nCómo trabajar remoto y no morir en el intento: el hilo definitivo. 😏🧵'
    },
    {
      'created_at': '2021-12-01T18:17:03.000Z',
      'id': '1466109100299890691',
      'text': 'Después de muchísimo esfuerzo y perseverancia conseguiste tu primer trabajo en IT. Y... ahora qué? Qué hay después de un junior?\n\nHablemos sobre cómo construir un plan de carrera profesional en tecnología. 👇🧵 +'
    },
    {
      'created_at': '2021-11-16T15:40:36.000Z',
      'id': '1460633910979842056',
      'text': 'Una startup es una muuuuy buena opción para conseguir tus primeras experiencias laborales en UX, pero casi siempre te piden "saber un poquito de todo". \n\nVeamos qué tenés que saber para convertirte en un UX/UI Designer unicornio (y no morir en el intento) 😏👇+'
    },
    {
      'created_at': '2021-11-08T21:02:42.000Z',
      'id': '1457815867601862661',
      'text': 'Lo voy a repetir hasta el hartazgo: El portfolio es el 50% de tu CV (si no es que más).\n\nAsí que 1, 2, 3: te dejo una checklist con todo lo que tiene que tener tu portfolio. Va con plantilla en Drive para que te guardes! 🙌 +'
    },
    {
      'created_at': '2021-10-25T19:01:32.000Z',
      'id': '1452711944612372481',
      'text': 'Conseguiste el trabajo que querías y después de sentirte la persona más feliz del mundo, una vocecita en tu cabeza te dice:\n¿Será que no me lo merezco? ¿Y si vieron más potencial en mí del que tengo? ¿Y si soy un fraude, una mentira?\n\nHablemos del Síndrome del Impostor 👇🧵'
    },
    {
      'created_at': '2021-09-20T22:39:46.000Z',
      'id': '1440083290103287812',
      'text': 'Tips para conseguir trabajo como diseñador UX y no morir en el intento 🤝\nConsejos simples, concisos, claros y útiles, como buena Uxer 🧵'
    },
    {
      'created_at': '2021-08-31T15:52:45.000Z',
      'id': '1432733105660518401',
      'text': 'Cambiando de carrera: de Diseñador Gráfico a Diseñador UX/UI. ✏️\nUna de las consultas que más recibo es ésta. Dudas, mitos, diferencias entre lo que abarca una u otra disciplina, si conviene o no conviene, etc. Hablemos de todo eso y un poco más 👇'
    },
    {
      'created_at': '2021-08-24T14:53:21.000Z',
      'id': '1430181442093559809',
      'text': '¿Cómo optimizar tu perfil de GitHub para conseguir trabajo? 👩‍💻\n\nGitHub es la mejor plataforma para presentar tus proyectos. Por qué? Porque exhibe tu trabajo, te permite hacer un seguimiento de versiones y es compatible con casi todos los repositorios de Windows, Linux o Mac. +'
    },
    {
      'created_at': '2021-08-10T14:05:11.000Z',
      'id': '1425095886774931465',
      'text': 'La clave para una entrevista de trabajo exitosa es estar PRE-PA-RA-DO. 🗒️\nY porque quiero que encuentres tu trabajo soñado, abro hilo sobre entrevistas laborales en TECH 👩‍💻: preguntas personales, actitudinales y técnicas. 🧵'
    },
    {
      'created_at': '2021-08-02T14:54:18.000Z',
      'id': '1422209145135116295',
      'text': 'Cómo optimizar tu CV para conseguir trabajo en IT? Te doy los mejores consejos, recomendaciones y plantillas gratis 👇 \n\nLeé hasta el final porque sorteamos diseño y traducción de CV 🚀 No te lo pierdas!'
    },
    {
      'created_at': '2021-07-22T23:38:44.000Z',
      'id': '1418354856050495488',
      'text': 'Mejora tu portfolio web con estos proyectos 🚀\n\n👩‍💻 Blog personal\n😜 Generador de memes/gifs\n💻 Landing page\n🛒 E-commerce\n💬 Live Chat \n🎨 Color picker\n⏰ Countdown timer\n⛅ App de clima\n🎧 Reproductor de música\n🖼️ Galería de fotos\n🃏 Memory game'
    },
    {
      'created_at': '2021-07-20T22:46:30.000Z',
      'id': '1417616936784039944',
      'text': 'Después del hilo de hoy, me preguntaron más sobre mi experiencia estudiando en @Coderhouse. Teniendo en cuenta que Coder fue definitivamente el impulso de mi carrera, acá va mi experiencia 👇👩‍💻'
    },
    {
      'created_at': '2021-07-20T14:45:47.000Z',
      'id': '1417495959941140482',
      'text': 'Por fin puedo compartir esta hermosa noticia: Soy Senior Analyst UX Designer en @AccentureUK! 🎉\n \nY te cuento todo lo que hice para llegar hasta acá. Quiero que todos consigamos nuestro trabajo soñado.\n \nAbro hilo, pero este es diferente, esta es mi historia 💛 https://t.co/cQNns9ATNK'
    },
    {
      'created_at': '2021-07-01T16:04:38.000Z',
      'id': '1410630434703224833',
      'text': '✨ La magia de LinkedIn ✨ Bien usado, te permite insertarte en el mercado laboral y conseguir el trabajo que queres. Mal usado, es una valiosa herramienta desperdiciada. \nEl hilo definitivo para optimizar tu LinkedIn, ya  🧵'
    },
    {
      'created_at': '2021-06-28T20:23:30.000Z',
      'id': '1409608418923618305',
      'text': 'Un día trabajando como diseñadora UX/UI 🤓\nTerminaste el curso de Diseño UX/UI. Y ahora qué? Cómo es trabajar de eso?\nTe cuento cómo es una jornada ejerciendo esta hermosa profesión (según mi experiencia, claro) 👇'
    },
    {
      'created_at': '2021-07-07T20:42:53.000Z',
      'id': '1412874787286917128',
      'text': 'Les quiero compartir algunos de mis portfolios favoritos de Desarrollo y Diseño Web 👩‍💻\n\nLos elegí porque reúnen lo que para mí hace a un portfolio atractivo\n\n✅Creatividad\n✅Claridad \n✅Storytelling\n\nPara inspirarse! 👇\n\n+'
    },
    {
      'created_at': '2021-07-06T20:30:11.000Z',
      'id': '1412509203789402112',
      'text': 'Todos te dicen que trabajes en tu portfolio, pero nadie te dice cómo generar ideas para hacerlo. 🎨 Te doy tips para desarrollar tu creatividad y que se te ocurran ideas increíbles 🧵'
    },
    {
      'created_at': '2021-04-09T15:02:47.000Z',
      'id': '1380536675546320896',
      'text': '🚀 UX/UI DESIGNER PORTFOLIO:\nEsta semana estuve trabajando en mi portfolio y quería compartirles lo que aprendí de varios procesos de reclutamiento 💛  \nAsique abro hilo con preguntas frecuentes y tips para que diseñen u optimicen su porftolio de diseño +'
    }
  ],
  herramientas: [
    {
      'created_at': '2022-07-13T14:35:52.000Z',
      'id': '1547228319350931457',
      'text': 'Si te dedicas al Diseño de Productos Digitales, este hilo es para vos 🧵\n\nTe dejo una lista de recursos y herramientas que van a  hacerte la vida más fácil 🧑‍💻👇'
    },
    {
      'created_at': '2022-07-19T14:20:25.000Z',
      'id': '1549398761583120385',
      'text': 'Hola UXer 👋\nHoy te traigo esta website donde podrás aprender Diseño de Interfaces jugando 🎮\n¡Presta atención a los detalles y elegí cuál es el mejor diseño! 👇\nhttps://t.co/LHF5P3BZJs'
    },
    {
      'created_at': '2022-07-25T20:42:33.000Z',
      'id': '1551669252679208962',
      'text': '¡Mejora tu productividad y organiza tu vida con Notion! 🗃️ \n\n(Y agendá la fecha de mi primer Stream en @Twitch)  👀'
    },
    {
      'created_at': '2022-02-07T19:03:40.000Z',
      'id': '1490763207174201344',
      'text': 'Me pasé toda la semana pasada preparándoles este regalito. 🎁\nLes presento a Universo UX/UI 🌈, una guía súper completa con +100 recursos en español con TODO lo que un Diseñador UX necesita: artículos, tutoriales, cursos, libros, comunidades, podcast, herramientas ¡y mucho más! https://t.co/z0eyv2oPeL'
    },
    {
      'created_at': '2021-11-25T13:17:02.000Z',
      'id': '1463859272262037508',
      'text': 'Alguien dijo +100 LIBROS GRATIS PARA DESCARGAR? \nhttps://t.co/iAyhD8pOB2 📚\n\nLos chicos de UX Links categorizaron y organizaron más de 100 libros de UX/UI (legales) 🌈'
    },
    {
      'created_at': '2021-11-24T16:04:45.000Z',
      'id': '1463539093653147649',
      'text': 'Alguna vez pensaste las horas de trabajo que te ahorra el atajo ctrl+c y ctrl+v? \n\nAbro hilo con tips y atajos para usar Figma like a pro😎👉 para que no trabajes de más, para simplificarte la vida y para que seas un UX/UI designer más productivo 🧵+'
    },
    {
      'created_at': '2021-08-13T13:20:00.000Z',
      'id': '1426171681110773760',
      'text': 'Conseguí aquí plantillas HTML GRATIS para agregar a tus proyectos 🤖\n\n📌 https://t.co/2wBRRjnDUd \n📌 https://t.co/dNMTZZaRgU \n📌 https://t.co/8xK6i4j36Z \n📌 https://t.co/zRYOK8aJsD\n📌 https://t.co/axCWJhqfjM \n📌 https://t.co/cw7FVQfEs5'
    },
    {
      'created_at': '2021-08-05T13:29:21.000Z',
      'id': '1423274931362537477',
      'text': 'Les traigo amor y 10 extensiones de Chrome para desarrolladores y diseñadores web 🌈\n\nNo se las pierdan 👇'
    },
    {
      'created_at': '2021-07-30T14:48:07.000Z',
      'id': '1421120428303605761',
      'text': '¡Aprende a programar jugando! 🎮\n\nHilo de juegos web para los niños (y no tan niños) que quieran aprender distintos lenguajes de programación de manera divertida 🚀'
    },
    {
      'created_at': '2021-07-15T13:33:38.000Z',
      'id': '1415665864435634183',
      'text': 'Aprende a usar Google like a pro 😎\n\n¿Sabías que googlear es una de las habilidades más importantes para todo desarrollador?\n\nTe dejo algunos tips y trucos para optimizar tus búsquedas en Google 🧵'
    },
    {
      'created_at': '2021-07-13T14:55:42.000Z',
      'id': '1414961742308945925',
      'text': 'Lista de los mejores podcast de tecnología en español 🎙️\n\nEscucha de la mano de profesionales temas como desarrollo web, programación, diseño y marketing digital para incorporar a tus días y seguir aprendiendo 👩‍💻👇'
    },
    {
      'created_at': '2021-06-07T19:54:10.000Z',
      'id': '1401990891695378438',
      'text': 'LO QUE LA NASA Y EL GOBIERNO NO QUIERE QUE SEPAS🤯\n\nCÓMO ENCONTRAR CURSOS GRATIS 🚀\n\n1. Ingresá a este link: https://t.co/2KnNQfOZCi\n2. Buscá filtrando por la categoría del curso que quieras (Desarrollo web, Diseño, Marketing, Excel, Javascript, Phyton, etc.)\n3. ¡Inscribite! 👩‍💻\n+'
    },
    {
      'created_at': '2021-05-10T19:39:56.000Z',
      'id': '1391840446641577988',
      'text': 'Hoy les traigo 4 herramientas gratuitas para organizar tu vida personal y profesional. ORGANIZA TUS PROYECTOS 🚀 +'
    },
    {
      'created_at': '2021-04-12T09:59:50.000Z',
      'id': '1381547600696983552',
      'text': '✏️Conocen daily UI? https://t.co/GHPbU44kpY Se trata de una plataforma en la que se suscriben y reciben un mail diario (excepto fines de semana) con pequeños retos que pueden ayudar a mejorar habilidades de la interfaz de usuario como tipografía, jerarquía, color, diseño 🎨 +'
    },
    {
      'created_at': '2021-07-02T18:30:00.000Z',
      'id': '1411029405686661122',
      'text': 'Hoy les traigo distintas plataformas de ejercicios para aprender Diseño UX/UI de forma didática y divertida 🚀\n\n1. https://t.co/8Loi3i919e\n2. https://t.co/cOPszYx7i5\n3. https://t.co/SBdTld3Wu5\n\nQue las disfruten! 🎨'
    },
    {
      'created_at': '2021-03-01T13:01:45.000Z',
      'id': '1366373092885491714',
      'text': 'Hoy les traigo CURSOS GRATIS DE UX/UI 📚\n1. UX Design: Conceptos básicos para principiantes https://t.co/xWpP37JkZl \n2. Fundamentos del diseño UX https://t.co/fQQ9A4LTz1\n3. Adobe XD: Aprender a crear prototipos profesionales desde 0 https://t.co/S01Am6qd7M'
    },
    {
      'created_at': '2021-03-05T15:35:17.000Z',
      'id': '1367861278199447552',
      'text': 'UX STARTER PACK BABY 🚀 la semana pasada les dejé recursos y herramientas de Diseño UX/UI, hoy quiero recomendarles libros, blogs, charlas y newsletters para aquellos que están comenzando en este hermoso mundo del UX (o aquellos como yo que aman la capacitación constante 😍) +'
    },
    {
      'created_at': '2021-03-26T12:10:31.000Z',
      'id': '1375419895920394243',
      'text': 'buen día! aquí les dejo el link a un tablero con información, recursos y herramientas de UX/UI 🚀 que armé especialmente para que tengan todo en un sólo lugar.\n📌 https://t.co/zUWWFTr7AG'
    },
    {
      'created_at': '2021-02-26T18:35:53.000Z',
      'id': '1365370012920332295',
      'text': '🧵 HILO DE RECURSOS Y HERRAMIENTAS PARA DISEÑO UX/UI ✨ Me basé en esta guía que encontré super interesante (https://t.co/dN9BA1O5WV) para organizar los recursos en cada etapa del proceso de diseño. Y ya saben que si quieren sumar info, SIEMPRE es más que bienvenida +'
    },
    {
      'created_at': '2021-07-09T22:16:51.000Z',
      'id': '1413623208364941312',
      'text': 'Si estás empezando en el desarrollo web, este hilo es para vos.\nTe dejo el top 10 de mejores plugins/extensiones en Visual Studio Code para hacerte la vida más fácil 👩‍💻'
    },
    {
      'created_at': '2021-04-01T13:00:00.000Z',
      'id': '1377606675549540352',
      'text': 'Recursos e información para aprender desarrollo (y diseño!) web 💻\n📌https://t.co/fbzNRbFvKS'
    },

  ],
  roadmap: [
    {
      'created_at': '2022-02-02T17:51:52.000Z',
      'id': '1488933198042124295',
      'text': '¿Querés poner en marcha tu carrera y empezar el camino hacia el éxito profesional? \n\nHablemos sobre cómo crecer como profesional en tecnología en 2022 🧑‍💻🧵'
    },
    {
      'created_at': '2021-10-29T14:53:46.000Z',
      'id': '1454099142926548995',
      'text': 'Hoja de ruta: Aprendé ReactJs 📚🤓\n\n1️⃣ Fundamentos de JavaScript:\n👉 Variables\n👉 Hoisting\n👉 Funciones\n👉 Métodos array\n👉 Objetos\n+'
    },
    {
      'created_at': '2021-08-10T15:31:41.000Z',
      'id': '1425117657544773637',
      'text': 'UX de 0 a 100: Cómo conseguir tu primer empleo en UX 🚀\n\nLes dejo el link al Meetup Virtual que brindé junto a los genios de @coderhouse \n\n📌https://t.co/a5rMqdCoqz'
    },
    {
      'created_at': '2021-07-19T18:45:00.000Z',
      'id': '1417193774061703171',
      'text': 'Ruta básica para ingresar al mundo de la programación👩‍💻\n\n1️⃣ Decidir lo que querés hacer: app, web, machine learning, etc.\n2️⃣ Aprender fundamentos de la programación: lógica, algoritmos, flujos de datos.\n3️⃣ Elegir un lenguaje apropiado: JavaScript, Python, etc.\n+'
    },
    {
      'created_at': '2021-05-14T16:08:51.000Z',
      'id': '1393236876744593415',
      'text': 'Hola amiguitos, les traigo un artículo que escribí para empezar en el diseño UX/UI de 0 a 100 🚀\nEs una guía SÚPER completa basada en mi experiencia, llena de recursos e ideas. Lean y compartan!  \n\nhttps://t.co/qQxZYNCPKQ'
    },
    {
      'created_at': '2021-04-13T14:55:13.000Z',
      'id': '1381984324506030087',
      'text': '🧵Hilo de recomendación sobre RUTAS DE APRENDIZAJE con los conocimientos que considero necesarios para convertirse en \n👩‍💻 DISEÑADOR UX/UI o DESARROLLADOR WEB FRONT-END +'
    },
  ],
  marcaPersonal: [
    {
      'created_at': '2022-05-24T12:18:04.000Z',
      'id': '1529074247502598145',
      'text': 'Todos podemos hacer networking, pero no todos lo hacemos bien. \n\nSi estás empezando a conectar con otros profesionales pero no está funcionando como esperabas, este hilo es para vos.\n\n 👉 Charlemos sobre buenas (y sobre todo, inteligentes) prácticas para hacer networking. 🧵'
    },
    {
      'created_at': '2022-01-24T15:03:57.000Z',
      'id': '1485629453296443400',
      'text': 'Siempre me pongo nerviosa cuando hago de speaker, pero la primera vez que hablé en público casi se me sale el corazón. Todo salió bien gracias a que supe organizarme y planificar todo, así que quiero compartir mi proceso con ustedes. \n\nCómo preparar disertaciones exitosas, YA🏃🧵'
    },
    {
      'created_at': '2022-01-12T15:18:50.000Z',
      'id': '1481284542140928010',
      'text': 'Hoy quiero compartir con ustedes tips y aprendizajes REALES para hacer networking.\n\nAplicables para damas, caballeros, introvertidos y extrovertidos. Todos pueden conectar. Arranquemos 👇🧵'
    },
    {
      'created_at': '2021-05-03T21:30:09.000Z',
      'id': '1389331469672329222',
      'text': 'Cómo desarrollar tu MARCA PERSONAL para conseguir el trabajo que querés 👩‍💻 \nABRO HILO 🧵+'
    },
    {
      'created_at': '2021-07-01T16:04:38.000Z',
      'id': '1410630434703224833',
      'text': '✨ La magia de LinkedIn ✨ Bien usado, te permite insertarte en el mercado laboral y conseguir el trabajo que queres. Mal usado, es una valiosa herramienta desperdiciada. \nEl hilo definitivo para optimizar tu LinkedIn, ya  🧵'
    },
    {
      'created_at': '2021-07-07T20:42:53.000Z',
      'id': '1412874787286917128',
      'text': 'Les quiero compartir algunos de mis portfolios favoritos de Desarrollo y Diseño Web 👩‍💻\n\nLos elegí porque reúnen lo que para mí hace a un portfolio atractivo\n\n✅Creatividad\n✅Claridad \n✅Storytelling\n\nPara inspirarse! 👇\n\n+'
    },
    {
      'created_at': '2021-07-06T20:30:11.000Z',
      'id': '1412509203789402112',
      'text': 'Todos te dicen que trabajes en tu portfolio, pero nadie te dice cómo generar ideas para hacerlo. 🎨 Te doy tips para desarrollar tu creatividad y que se te ocurran ideas increíbles 🧵'
    },
    {
      'created_at': '2021-04-09T15:02:47.000Z',
      'id': '1380536675546320896',
      'text': '🚀 UX/UI DESIGNER PORTFOLIO:\nEsta semana estuve trabajando en mi portfolio y quería compartirles lo que aprendí de varios procesos de reclutamiento 💛  \nAsique abro hilo con preguntas frecuentes y tips para que diseñen u optimicen su porftolio de diseño +'
    }
  ]
}

export default data